export default __webpack_public_path__ + "static/media/logo_albu.e23932c0.png";